<!-- 征文&通知 -->
<template>
  <div class="">
    <div class="header">
      <div class="user" @click="$router.go(-1)">
        <Icon type="ios-arrow-back" size="22" />
      </div>
    </div>
    <!-- 简洁名片 -->
    <plain-card></plain-card>
    <!-- 通知区域 -->
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
    >
      <div
        class="content"
        v-for="(item, index) in list_git"
        :key="index"
        @click="livstTop(item)"
      >
        <div class="top">
          公告：<span>{{ item.title }}</span>
        </div>
        <div class="middle">
          <span>{{ item.content }}</span>
        </div>
        <div class="bottom">{{ item.createTime }}</div>
        <div class="line"></div>
      </div>
    </van-list>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import plainCard from "@/components/plain_card";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    plainCard,
  },
  data() {
    //这里存放数据
    return {
      perParams: {
        pages: 1,
        pageSize: 5,
      },
      total: 10,
      text: "上拉加载更多",
      sousuo: "",
      Announ_list: [],
      list_git: [],
      list: [],
      loading: false,
      finished: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onLoad() {
      setTimeout(() => {
        // for (let i = 0; i < 10; i++) {
        //   this.list.push(this.list.length + 1);
        // }
        // // 加载状态结束
        this.loading = false;
        // // 数据全部加载完成

        this.perParams.pages++;
        this.annoud();
        if (this.list_git.length >= this.total) {
          this.finished = true;
          this.text = "没有更多了";
          this.loading = false;
          // this.perParams.pages = this.perParams.pages;
        }
      }, 1000);
    },
    //公告接口调用
    annoud() {
      var data = {
        pageNo: this.perParams.pages,
        pageSize: this.perParams.pageSize,
        periodicalId: this.$store.state.qikanId,
        title: this.sousuo,
      };
      this.$apis.manage.Announ(data).then((res) => {
        this.Announ_list = res.content.list.list;
        this.total = res.content.list.total;
        this.Announ_list.map((item) => {
          this.list_git.push(item);
          item.createTime = item.createTime.replace(/-/g, "/").substring(0, 10);
        });
      });
    },

    livstTop(data) {
      this.$router.push({
        path: "/noticeDetails",
        query: {
          id: data.id,
          editId: this.$route.query.editId,
          perId: this.$route.query.perId,
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //公告
    this.annoud();

    // this.getHeight();
    //let _this = this;
    // window.onscroll = function () {
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   //变量windowHeight是可视区的高度
    //   var windowHeight =
    //    document.documentElement.clientHeight || document.body.clientHeight;
    //   //变量scrollHeight是滚动条的总高度
    //   var scrollHeight =
    //     document.documentElement.scrollHeight || document.body.scrollHeight;
    //   //滚动条到底部的条件
    //   if (scrollTop + windowHeight == scrollHeight) {
    //     setTimeout(function () {
    //       if (_this.perParams.pageSize == _this.Announ_list.length) {
    //         _this.perParams.pages++;
    //         _this.annoud();
    //       } else {
    //         _this.text = "暂无数据";
    //       }
    //     }, 1000);
    //   }
    // };
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.scroll-view {
  /* -- Attention: This line is extremely important in chrome 55+! -- */
  touch-action: none;
  /* -- Attention-- */
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.header {
  height: 52px;
  line-height: 52px;
  text-align: center;
  padding: 0 18px;
  display: flex;
  justify-content: flex-start;
  background-color: #fff;
  margin-bottom: 15px;
  .user {
    display: flex;
    // justify-content: space-around;
    align-items: center;
    width: 100px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
//@import url(); 引入公共css类
.content {
  background-color: #fff;
  padding: 20px 19px 0 19px;
  .line {
    background: #e6e6e6;
    height: 1px;
  }
  .top {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
    line-height: 29px;
    margin-bottom: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .middle {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #999999;
    line-height: 29px;
    margin-bottom: 20px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .bottom {
    font-size: 13px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #999999;
    margin-bottom: 20px;
  }
}
</style>
